module.exports = __webpack_public_path__ + "static/img/reg.296b2f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reg.jpg
// module id = 3nwQ
// module chunks = 6